import application from './application';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [application]
};

export default menuItems;
